import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';

import { CalculatorStepAccordion, useForm } from '@ratehub/base-ui';
import { AmortizationSchedule, SCENARIO_TYPES } from '@ratehub/mtg-common';

import getMortgageScenarioChooserOptionsPayment from '../functions/getMortgageScenarioChooserOptionsPayment';
import getSelectedPaymentCalculatorScenario from '../functions/getSelectedPaymentCalculatorScenario';
import InlineScenarioSelect from './InlineScenarioSelect';


function PaymentCalculatorStepAmortizationSchedule({
    scenarioType,
    stepNumber,
    scenarioCount,

    onChangeScenario,
    onToggleExpand,

    ...otherProps
}) {
    const form = useForm();
    const selectedScenarioNumber = form.values.selectedScenarioNumber - 1;

    return (
        <>
            <CalculatorStepAccordion
                accordionDataName={`calculator-step[${stepNumber}].mtg-paymentCalculator-amortizationScheduleAccordion`}
                title={(
                    <FormattedMessage
                        id="calculators.PaymentCalculatorStepAmortizationSchedule.title"
                        defaultMessage="Amortization schedule"
                    />
                )}
                showBadge={false}
                stepNumber={stepNumber}
                onToggleExpand={onToggleExpand}
                canBeDisabled
                {...otherProps}
            >
                <If condition={scenarioCount > 1}>
                    <InlineScenarioSelect
                        label={(
                            <FormattedMessage
                                id="calculators.PaymentCalculatorStepAmortizationSchedule.scenarioLabel"
                                defaultMessage="Choose your amortization scenario"
                            />
                        )}
                        options={getMortgageScenarioChooserOptionsPayment(scenarioType, scenarioCount)}
                        initialValue={getSelectedPaymentCalculatorScenario(
                            form.values.selectedScenarioNumber,
                            scenarioCount,
                        )}
                        onChange={onChangeScenario}
                    />
                </If>

                <AmortizationSchedule
                    totalMortgage={
                        scenarioType === SCENARIO_TYPES.PURCHASE
                            ? form.values.scenarios[selectedScenarioNumber].totalMortgage
                            : form.values.mortgageAmount
                    }
                    mortgageRate={form.values.scenarios[selectedScenarioNumber].selectedRate?.value}
                    termInYears={form.values.scenarios[selectedScenarioNumber].selectedRate?.term / 12}
                    amortization={parseInt(form.values.scenarios[selectedScenarioNumber].amortization)}
                    paymentFrequency={form.values.scenarios[selectedScenarioNumber].paymentFrequency}
                />
            </CalculatorStepAccordion>
        </>
    );
}

PaymentCalculatorStepAmortizationSchedule.propTypes = {
    scenarioType: PropTypes.oneOf(Object.values(SCENARIO_TYPES)),
    stepNumber: PropTypes.number.isRequired,
    scenarioCount: PropTypes.number.isRequired,

    onChangeScenario: PropTypes.func.isRequired,
    onToggleExpand: PropTypes.func,
};

PaymentCalculatorStepAmortizationSchedule.defaultProps = {
    scenarioType: SCENARIO_TYPES.PURCHASE,
    onToggleExpand: undefined,
};

export default observer(PaymentCalculatorStepAmortizationSchedule);
